import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import { useShippingPrice } from 'dibs-search-product-tile/exports/useShippingPrice';

import { type ProductShipping_viewer$key } from './__generated__/ProductShipping_viewer.graphql';
import { type ProductShipping_item$key } from './__generated__/ProductShipping_item.graphql';

import dibsCss from 'dibs-css';

const viewerFragment = graphql`
    fragment ProductShipping_viewer on Viewer {
        ...useShippingPrice_viewer
    }
`;
const itemFragment = graphql`
    fragment ProductShipping_item on Item {
        ...useShippingPrice_item
    }
`;

type Props = {
    viewer: ProductShipping_viewer$key | null | undefined;
    item: ProductShipping_item$key | null | undefined;
    currency: string;
};

export const ProductShipping: FC<Props> = ({ viewer: viewerRef, item: itemRef, currency }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const item = useFragment(itemFragment, itemRef);
    const amount = useShippingPrice({ item, viewer, currency });

    if (amount === 0) {
        return (
            <p
                className={classnames(
                    dibsCss.textBodyXSmallHeavy,
                    dibsCss.textInternalsecondary,
                    dibsCss.mt2px
                )}
            >
                <FormattedMessage
                    id="dc.buyerProductTile.freeShipping"
                    defaultMessage="Free Shipping"
                />
            </p>
        );
    }
    return null;
};
